<div class="registration-container">
  <form [formGroup]="changePwdForm" (ngSubmit)="changePassword()" class="form-container">
    <h3 class="section-title">Change Password</h3>

    <mat-form-field appearance="outline" class="full-width-field">
      <mat-label>User Name</mat-label>
      <input matInput formControlName="login" required>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width-field">
      <mat-label>Old Password</mat-label>
      <input matInput type="password" formControlName="old_password" required autocomplete="off" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width-field">
      <mat-label>New Password</mat-label>
      <input matInput type="password" formControlName="new_password" required autocomplete="off" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width-field">
      <mat-label>Confirm Password</mat-label>
      <input matInput type="password" formControlName="confirmpassword" required autocomplete="off" />
    </mat-form-field>

    <button mat-raised-button class="submit-btn" type="submit">
      Change Password
    </button>
  </form>
</div>
